export default function authHeader() {
  const user = JSON.parse(localStorage.getItem("user"));
  if (user && user.access_token) {
    return { 'Accept': 'application/json','Content-type': 'application/json', 'X-Requested-With': 'XMLHttpRequest', 'Authorization': "Bearer " + user.access_token };
  } else {
    return { 'Content-type': 'application/json', 'X-Requested-With': 'XMLHttpRequest'};
  }
}
